import EventID from '@/model/EventClass/EventID'

class EventClassMap {
  private static eventClassMap: EventClassMap

  private events: Record<string, number> = {}

  constructor() {
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextDif'] = EventID.TextDif
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventAd'] = EventID.Ad
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventAdChoice'] = EventID.AdChoice
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventAdEnd'] = EventID.AdEnd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventAddItem'] = EventID.AddItem
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventAutoPlay'] = EventID.AutoPlay
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventBGMAdd'] = EventID.BGMAdd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventBackTitle'] = EventID.BackTitle
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventBookMark'] = EventID.BookMark
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventBubble'] = EventID.Bubble
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventBubbleMode'] = EventID.AirBubbleMode
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventButtonDif'] = EventID.ButtonDif
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventButtonDifChoose'] = EventID.ButtonDifChoose
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventButtonDifEnd'] = EventID.ButtonDifEnd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventCGAdd'] = EventID.CGAdd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventCallMenu'] = EventID.CallMenu
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventCallSubStory'] = EventID.CallSubStory
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventComment'] = EventID.Comment
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventConvertSceneStart'] = EventID.ConvertSceneStart
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventDisableMenu'] = EventID.DisableMenu
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventDisposePic'] = EventID.DisposePic
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventDisposeText'] = EventID.DisposeText
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventFadeBGM'] = EventID.FadeBGM
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventFadeBGS'] = EventID.FadeBGS
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventFlash'] = EventID.Flash
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventFloatControl'] = EventID.FloatControl
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventForcedSaveRead'] = EventID.ForcedSaveRead
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventFreshUI'] = EventID.FreshUI
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventGifPicShow'] = EventID.GifPicShow
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventIF'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.VarClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.VarExClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.FlowerClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.MouseClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.PlateFormClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.PayClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.TaskClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.MallClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.LimiteMallClass'] = EventID.IF
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventIFEnd'] = EventID.IFEnd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventIfChoice'] = EventID.IfChoice
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventJumpStory'] = EventID.JumpStory
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventJumpStoryUI'] = EventID.JumpStoryUI
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventLoop'] = EventID.Loop
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventLoopAboveStart'] = EventID.LoopAboveStart
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventLoopBreak'] = EventID.LoopBreak
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventMaskPic'] = EventID.MaskPic
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventMoodShow'] = EventID.MoodShow
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventMovePic'] = EventID.MovePic
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventNotSelect'] = EventID.NotSelect
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventOaf'] = EventID.Oaf2
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventOpenUrl'] = EventID.OpenUrl
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventPicShow'] = EventID.PicShow
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventPlanConvertScene'] = EventID.PlanConvertScene
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventPromptMessage'] = EventID.PromptMessage
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventQuickPlay'] = EventID.QuickPlay
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventResourceLoad'] = EventID.ResourceLoad
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventReturnGameUI'] = EventID.ReturnGameUI
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventRotatePic'] = EventID.RotatePic
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventSendAirBubble'] = EventID.SendAirBubble
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventSeniorIF'] = EventID.SeniorIf
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventSeniorVar'] = EventID.SeniorVar
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventShake'] = EventID.Shake
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventSimpleEffect'] = EventID.SimpleEffect
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStartBGM'] = EventID.StartBGM
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStartBGS'] = EventID.StartBGS
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStartSE'] = EventID.StartSE
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStartVoice'] = EventID.StartVoice
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStopSE'] = EventID.StartSE
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStopVoice'] = EventID.StopVoice
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventStoryLock'] = EventID.StoryLock
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventString'] = EventID.String
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventText'] = EventID.Text
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextChoice'] = EventID.TextChoice
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextDif'] = EventID.TextDif
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextDifEx'] = EventID.TextDifEx
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextDifEx2'] = EventID.TextDifEx2
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventTextEnd'] = EventID.TextEnd
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventUnlockCollect'] = EventID.UnlockCollect
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventUpateSceneHue'] = EventID.UpateSceneHue
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventValueInput'] = EventID.ValueInput
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventVar'] = EventID.Var
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventVarsEx'] = EventID.VarsEx
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventVitLock'] = EventID.VitLock
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventWait'] = EventID.Wait
    this.events['ORG.AvgMaker.DataStructure.EventClass.EventWeather'] = EventID.Weather
  }

  public static getInstance(): EventClassMap {
    if (this.eventClassMap === undefined) {
      this.eventClassMap = new EventClassMap()
    }
    return this.eventClassMap
  }

  public getEventClassID(className: string): number {
    return this.events[className] ?? EventID.NotSelect
  }

  public removeEventBaseP(obj: Record<string, unknown>): void {
    const basePrefix = 'EventBase+'
    for (const key of Object.keys(obj)) {
      if (key.includes(basePrefix)) {
        const nextKey = key.replace(basePrefix, '')
        obj[nextKey] = obj[key]
        Reflect.deleteProperty(obj, key)
      }
    }
  }
}

export default EventClassMap
